<template>
  <div :class="containerClass">
    <component
      :is="file.url ? 'a' : 'div'"
      :href="file.url"
      download
      :class="componentClass"
      :title="variant === 'grid' ? file.filename : null"
    >
      <!-- List Variant -->
      <template v-if="variant === 'list'">
        <i
          class="pi mr-3"
          :class="{
            'pi-download text-slate-600': file.url,
            'pi-hourglass text-yellow-600': !file.scanned,
            'pi-times-circle text-red-600': file.scanned && !file.safe,
          }"
        ></i>
        <span class="flex-1 text-slate-800">
          {{ file.filename }}
          <span class="text-xs text-slate-500">
            {{ file.size ? ` (${formatFileSize(file.size)})` : '' }}
          </span>
        </span>
        <span
          v-if="!file.scanned"
          class="text-xs px-2 py-1 bg-yellow-100 text-yellow-800 rounded mr-2"
        >
          Nescanat
        </span>
        <span
          v-else-if="!file.safe"
          class="text-xs px-2 py-1 bg-red-100 text-red-800 rounded mr-2"
        >
          Nesigur
        </span>
        <span class="text-xs text-slate-500">
          {{ formatDate(file.created_at) }}
        </span>
      </template>

      <!-- Grid Variant -->
      <template v-else>
        <div
          class="mb-2 w-16 h-16 flex items-center justify-center bg-slate-100 rounded-lg border border-slate-200 relative"
        >
          <i class="pi pi-file text-2xl text-slate-600"></i>
          <span
            v-if="!file.scanned"
            class="absolute -top-1 -right-1 w-5 h-5 bg-yellow-500 rounded-full flex items-center justify-center"
          >
            <i class="pi pi-spin pi-spinner text-white text-xs"></i>
          </span>
          <span
            v-else-if="!file.safe"
            class="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center"
          >
            <i class="pi pi-times text-white text-xs"></i>
          </span>
        </div>
        <span class="text-xs text-slate-800 max-w-[80px] truncate">
          {{ file.filename }}
        </span>
        <span class="text-xs text-slate-500 max-w-[80px] truncate">
          {{ formatDate(file.created_at) }}
        </span>
      </template>
    </component>
    <button
      v-if="onDelete && variant === 'list'"
      class="ml-2 p-1 text-red-600 hover:bg-red-50 rounded transition-colors"
      :disabled="isDeleting"
      title="Sterge fisierul"
      @click="handleDelete"
    >
      <i class="pi pi-trash"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    file: {
      type: Object,
      required: true,
    },
    variant: {
      type: String,
      default: 'list', // 'list' or 'grid'
    },
    onDelete: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      isDeleting: false,
    };
  },
  computed: {
    containerClass() {
      if (this.variant === 'grid') {
        return [
          'flex flex-col items-center text-center',
          { 'hover:opacity-75 transition-opacity': this.file.url },
        ];
      }
      return [
        'flex items-center p-3 bg-white rounded border border-slate-200',
        {
          'hover:bg-slate-50 hover:border-slate-300 transition-colors':
            this.file.url,
        },
      ];
    },
    componentClass() {
      if (this.variant === 'grid') {
        return ['flex flex-col items-center text-center flex-1'];
      }
      return ['flex items-center flex-1'];
    },
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleDateString('ro-RO', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    formatFileSize(size) {
      if (size < 1024) return `${size} B`;
      if (size < 1024 * 1024)
        return `${parseFloat((size / 1024).toFixed(1))} KB`;
      if (size < 1024 * 1024 * 1024)
        return `${parseFloat((size / (1024 * 1024)).toFixed(1))} MB`;
      return `${parseFloat((size / (1024 * 1024 * 1024)).toFixed(1))} GB`;
    },
    async handleDelete() {
      if (!this.onDelete) return;
      this.isDeleting = true;
      try {
        await this.onDelete(this.file);
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>
